module.exports = __webpack_public_path__ + "static/img/UBIDOMO_slide-6-1500x630.d6c489ee.jpg";